<div class="products__reload-message">
  <p>{{message}}</p>
</div>
